import React, { Component } from 'react'
import Map from './Core'
import FontIcon from '../../atoms/FontIcon'
import T from '../../../SPRINTA/translate/T'
import style from './style.css'
export default class GoogleAutocomplete extends Component {
    constructor(props) {
        super(props)
        this.init = this.init.bind(this)
    }
    
    componentDidMount() {
        Map((google) => {
            this.init(google.maps)
        })
    }

    init(google) {
        let autocomplete = new google.places.Autocomplete(this.refs.autocomplete)

        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();
            let lat = place.geometry.location.lat()       
            let lng = place.geometry.location.lng()
            
            this.props.handleUpdate(lat, lng)     

        }.bind(this))
            
    }
  
    render() {
        return (
            <div>
                <input placeholder={T.txt('find_location')} ref="autocomplete" className={style.autocomplete} />
                <span className={style.search}>
                    <FontIcon name="search"/>
                </span>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/third-party/GoogleMap/Autocomplete.js